import React, { useEffect, useState } from "react";
import Navbarnft_global from "./Navbars/Navbarnft_global";
import Footer from "./Footer";
import Browse1 from "../Images/browse_art.webp";

import gold from "../Images/tick_gold.png";
import blue from "../Images/tick_blue.png";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Tooltip } from "antd";

function Art({ URL, UserWallet }) {
  const { cat } = useParams();

  const [collection, setCollection] = useState([]);
  useEffect(() => {
    const init = async () => {
      axios
        .post(`${URL}/collectionbycat`, {
          cat: cat,
        })
        .then((res) => {
          console.log(res.data);
          setCollection(res.data);
        })
        .catch(console.error);
    };
    init();
  }, []);

  return (
    <div>
      <Navbarnft_global URL={URL} UserWallet={UserWallet} />

      <div className="w3-container ex-hero">
        <span className="w3-eyebrow">Category</span>
        <h1 className="w3-gradient-text" style={{ textTransform: "capitalize" }}>{cat}</h1>
      </div>

      <div className="w3-container" style={{ paddingBottom: 64 }}>
        <div className="row">
          {collection.map((res) => {
            return (
              <div className=" col-lg-3 col-md-4 col-sm-6 col-12 browse-card m-y-1">
                <Link
                  to={`collection/${res.name
                    .toLowerCase()
                    .replace(/\s+/g, "-")}/${res.Collection_id}`}
                  className=""
                >
                  <div className="">
                    <div className="bt_br o-h m-q-h-25 w-100">
                      <img
                        src={res.logoImage}
                        alt=""
                        className="d-f a-i-c j-c-c o-f-c w-100 h-100 "
                      />
                    </div>
                    <div className="notable_card p-x-1 ">
                      <div className=" p-y-1_5 f-w-600">
                        {" "}
                        <div className="d-f a-i-c">
                          <div className="m-r-1">{res.name} </div>
                          <div className="">
                            {res.tick ? (
                              res.tick == "gold" ? (
                                <Tooltip title="Sharia Compliant">
                                  <img src={gold} className="w-1_5" />
                                </Tooltip>
                              ) : res.tick == "blue" ? (
                                <Tooltip title="Verified">
                                  {" "}
                                  <img src={blue} className="w-1_5" />
                                </Tooltip>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
        {collection.length > 0 ? (
          ""
        ) : (
          <div className="p-y-5 t-a-c">No data to show...</div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Art;
